/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bulk_Delete_Chats_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to delete some chats. Please try again." |
*
* @param {Bulk_Delete_Chats_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bulk_delete_chats_error = /** @type {((inputs?: Bulk_Delete_Chats_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bulk_Delete_Chats_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einige Chats konnten nicht gelöscht werden. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to delete some chats. Please try again.")
});